import { useEffect, useRef } from 'react';

import { PieceAnnotation } from '@apiContract';

import { useGetPieceAnnotationFilteredQuery } from '@redux/api/pieceAnnotation';

export const usePieceAnnotations = (onFetch: (annotations: PieceAnnotation[]) => void, pieceId: number | null) => {
  const onFetchRef = useRef(onFetch);

  onFetchRef.current = onFetch;

  const { data, isLoading, refetch } = useGetPieceAnnotationFilteredQuery(
    { PieceId: pieceId || undefined },
    { skip: !pieceId, refetchOnMountOrArgChange: true },
  );

  useEffect(() => {
    if (data?.items) {
      onFetchRef.current(data.items || []);
    }
  }, [data]);

  return { isLoading, refetch };
};
